import React from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Topbar } from "@components";
import styled from "styled-components";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useTranslation } from "react-i18next";
import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import {
	Divider as AntDivider,
} from "antd";

const RootContainer = styled.div`
  padding: 0px 16px;
`;

const Divider = styled(AntDivider)`
	/* padding: 0px 30px 12px 30px; */
	.ant-divider-inner-text {
		font-size: 14px;
		font-weight: 400;
		color: ${(props) => props.theme.textColor};
		background: white;
		border-radius: 21px;
		padding: 4px 16px;
	}

	::before,
	::after {
		border: 1px solid ${(props) => props.theme.divider};
		border-color: ${(props) => props.theme.divider} !important;
	}
`;

const Rules = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
  };

  if (!state) {
    return <Navigate to={`/${PUBLIC_ROUTE.SPIN_HOME}`} />;
  }

  const ruleText =
    userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
      ? state.text_en
      : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
        ? state.text_mm
        : state.text_ch;
  
  return (
    <>
      <Topbar title={t("spin.rule")} goBack={goBack} />
      <RootContainer>
        <Divider>{t("spin.spinRuleTitle")}</Divider>
        <div dangerouslySetInnerHTML={{ __html: ruleText }} />;
      </RootContainer>
    </>
  );
};

export default Rules;
